var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 416.4 91.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 236.86,
    y1: 68.31,
    x2: 236.86,
    y2: 28.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f15a24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa51a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 263.41,
    y1: 67.85,
    x2: 263.41,
    y2: 34.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 292.74,
    y1: 68.31,
    x2: 292.74,
    y2: 34.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 332.13,
    y1: 68.31,
    x2: 332.13,
    y2: 34.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 370.29,
    y1: 67.85,
    x2: 370.29,
    y2: 23.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 402.11,
    y1: 68.28,
    x2: 402.11,
    y2: 34.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 20.94,
    y1: 47.73,
    x2: 3.29,
    y2: 97.59,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.79,67.85V26.49h8.86l0,34.29h17.24v7.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.62,34.88a18.74,18.74,0,0,1,7.16,1.36,15.88,15.88,0,0,1,5.63,3.82,16.37,16.37,0,0,1,3.53,6.12,21.11,21.11,0,0,1,.95,8H113.62a9.52,9.52,0,0,0,3.23,5.48,8.81,8.81,0,0,0,5.77,2,9,9,0,0,0,5.06-1.45,9.57,9.57,0,0,0,3.42-4.08l7.12,3.4a15.75,15.75,0,0,1-6.4,6.39,18.85,18.85,0,0,1-9.2,2.32,19.25,19.25,0,0,1-8.76-2,15.79,15.79,0,0,1-6.38-5.84,16.26,16.26,0,0,1-2.43-8.87,16.35,16.35,0,0,1,2.43-8.88,15.68,15.68,0,0,1,6.38-5.85A19.25,19.25,0,0,1,122.62,34.88Zm0,6.61a8.92,8.92,0,0,0-5.9,2,9.11,9.11,0,0,0-3.1,5.5h18a9.33,9.33,0,0,0-3.11-5.5A8.93,8.93,0,0,0,122.62,41.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.88,34.88A17.08,17.08,0,0,1,167,36.27a9.41,9.41,0,0,1,4.45,3.86l.38-4.75h7.93V67.85h-7.93l-.38-4.79q-2.66,5.25-11.56,5.25a14.57,14.57,0,0,1-6-1.26A14.94,14.94,0,0,1,149,63.64a15.8,15.8,0,0,1-3.25-5.29,19.5,19.5,0,0,1,0-13.47A15.89,15.89,0,0,1,149,39.57a15,15,0,0,1,4.85-3.43A14.57,14.57,0,0,1,159.88,34.88Zm2.25,26.39a9,9,0,0,0,6.61-2.72,9.48,9.48,0,0,0,2.7-6.95,9.42,9.42,0,0,0-2.7-6.94A8.94,8.94,0,0,0,162.13,42a8.81,8.81,0,0,0-6.56,2.71,9.5,9.5,0,0,0-2.67,7,9.46,9.46,0,0,0,2.68,6.92A8.8,8.8,0,0,0,162.13,61.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.37,34.88a17.08,17.08,0,0,1,7.11,1.39,9.41,9.41,0,0,1,4.45,3.86V23.55h8.31v44.3h-8l-.35-4.79q-2.66,5.25-11.56,5.25a14.57,14.57,0,0,1-6-1.26,15.13,15.13,0,0,1-4.87-3.41,15.82,15.82,0,0,1-3.26-5.29,19.5,19.5,0,0,1,0-13.47,15.91,15.91,0,0,1,3.26-5.31,15.18,15.18,0,0,1,4.87-3.43A14.57,14.57,0,0,1,200.37,34.88Zm2.25,26.39a8.93,8.93,0,0,0,6.6-2.74,9.41,9.41,0,0,0,2.71-6.92,9.41,9.41,0,0,0-2.7-6.93A8.92,8.92,0,0,0,202.62,42a8.81,8.81,0,0,0-6.56,2.71,9.5,9.5,0,0,0-2.67,7,9.46,9.46,0,0,0,2.68,6.92A8.8,8.8,0,0,0,202.62,61.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.91,28.05h8.3v7.33h8v6.48h-8V56.6q0,4,3,4.41a12.33,12.33,0,0,0,5,0v6.83a38.17,38.17,0,0,1-6.06.52q-5.56,0-7.91-2.8c-1.57-1.86-2.35-4.74-2.35-8.62v-15H226.5V35.38h4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.52,35.38h8l.34,4.06a10.43,10.43,0,0,1,4.57-3.56,19.85,19.85,0,0,1,6.91-1V42q-5.48,0-8.48,2.61a8.87,8.87,0,0,0-3,7V67.85h-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.46,34.88a17.08,17.08,0,0,1,7.11,1.39A9.36,9.36,0,0,1,302,40.13l.38-4.75h7.93V67.85H302.4L302,63.06q-2.65,5.25-11.56,5.25a14.49,14.49,0,0,1-6-1.26,14.87,14.87,0,0,1-4.86-3.41,15.8,15.8,0,0,1-3.25-5.29,19.65,19.65,0,0,1,0-13.47,15.89,15.89,0,0,1,3.25-5.31,14.92,14.92,0,0,1,4.86-3.43A14.49,14.49,0,0,1,290.46,34.88Zm2.25,26.39a9,9,0,0,0,6.62-2.72A9.51,9.51,0,0,0,302,51.6a9.45,9.45,0,0,0-2.69-6.94A9,9,0,0,0,292.71,42a8.83,8.83,0,0,0-6.56,2.71,9.5,9.5,0,0,0-2.67,7,9.46,9.46,0,0,0,2.68,6.92A8.8,8.8,0,0,0,292.71,61.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M333.23,61.45a8.55,8.55,0,0,0,4.58-1.26,8.42,8.42,0,0,0,3.2-3.65l7.62,3.09A15,15,0,0,1,342.41,66a18.44,18.44,0,0,1-9.18,2.34,19.29,19.29,0,0,1-8.77-2,15.78,15.78,0,0,1-6.4-5.84,16.26,16.26,0,0,1-2.42-8.87,16.34,16.34,0,0,1,2.42-8.88,15.66,15.66,0,0,1,6.4-5.85,19.3,19.3,0,0,1,8.77-2,18.44,18.44,0,0,1,9.18,2.34,15,15,0,0,1,6.22,6.35L341,46.68a8.42,8.42,0,0,0-3.2-3.65,8.63,8.63,0,0,0-4.58-1.25,8.91,8.91,0,0,0-6.62,2.74,9.64,9.64,0,0,0-2.7,7.08,9.69,9.69,0,0,0,2.7,7.09A8.89,8.89,0,0,0,333.23,61.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M385.89,35.38,373,49.05l12.87,18.8h-9.4l-8.89-13L363,59.69v8.16h-8.34V23.55H363V49.16l12.89-13.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M415.53,43.65l-8.3.55a4.18,4.18,0,0,0-1.72-2.44,5.54,5.54,0,0,0-3.36-1,7,7,0,0,0-3.8.91,2.88,2.88,0,0,0-1.45,2.61,2.55,2.55,0,0,0,.85,1.94,5.87,5.87,0,0,0,2,1.22,30.81,30.81,0,0,0,3.22.9q2.94.7,4.93,1.3a29.31,29.31,0,0,1,3.76,1.43,9.29,9.29,0,0,1,2.74,1.8,7,7,0,0,1,1.52,2.31,7.26,7.26,0,0,1,.49,3,9,9,0,0,1-3.82,7.47q-3.68,2.61-10.25,2.62-6.34,0-10.19-2.42a9,9,0,0,1-4.32-7l8.25-.69a4.62,4.62,0,0,0,2.22,3,8.43,8.43,0,0,0,8.13.07A3.17,3.17,0,0,0,408,58.5a3.32,3.32,0,0,0-2-2.87,20.7,20.7,0,0,0-5.44-1.91c-2.36-.56-4.22-1.07-5.56-1.53a15.24,15.24,0,0,1-3.62-1.77,5.9,5.9,0,0,1-2.22-2.54,9.51,9.51,0,0,1-.62-3.68,7.77,7.77,0,0,1,3.66-6.92q3.66-2.4,10.15-2.4c3.87,0,6.95.75,9.25,2.23A8.42,8.42,0,0,1,415.53,43.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "42.9 55.77 30.59 65.12 17.27 75.24 13.32 78.24 0 88.36 0 36.8 13.32 26.68 13.32 62.47 17.27 59.47 30.59 49.35 46.28 35.5 42.9 55.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2.22 91.86 13.32 91.86 13.32 83.43 2.22 91.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "59.39 76.94 49.43 91.86 17.27 91.86 17.27 80.43 21.76 77.02 30.59 70.31 30.59 77.02 59.39 76.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30.59 0 30.59 44.35 17.27 54.47 17.27 10.12 30.59 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.e2de66cc19f5b4f0bb5cffe85f56a3fa.svg";
export { ForwardRef as ReactComponent };